module.exports = __webpack_public_path__ + "static/img/04.dae68bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/FamilyAlbum/04.jpg
// module id = cgd8
// module chunks = 7